var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"sitekey":"6LdkJ4UcAAAAACp10NcAdnUXlQa2pmWN0qe_qQSl"},on:{"verify":_vm.onVerify}})}
var staticRenderFns = []

export { render, staticRenderFns }